import { useMemo, useRef } from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';

export default function Maps({ loc, changeLocation }) {
    const markerRef = useRef(null);
    const eventHandlers = useMemo(
        () => ({
            dragend() {
                const marker = markerRef.current
                if (marker) changeLocation(marker.getLatLng());
            },
        }),
        [changeLocation],
    )
    return (
        <div className='maps'>
            <MapContainer center={loc} zoom={15} scrollWheelZoom={false} zoomControl={false}>
                <TileLayer
                    url='https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png?api_key=7a065d90-549d-4433-b863-5e07c0d3e214'
                    // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker
                    draggable={!!changeLocation}
                    position={loc}
                    eventHandlers={eventHandlers}
                    ref={markerRef}
                />
            </MapContainer>
        </div >
    );
}

